import {
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { FC, useEffect, useState } from "react";
import mutation from "../../mutation";
import ComboTabs from "../../contrainers/ComboTabs";
import SportTableLiveAndToday from "../../contrainers/SportTableLiveAndToday";
import query from "../../query";
import {
  DEFAULT_PROVIDER,
  isSabaComboDisabled,
} from "../../utils/providerQuery";

const Combo: FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const queryClient = useQueryClient();
  const providerQuery = query.provider();
  const pvd = useQuery(providerQuery.key, providerQuery.queryFn, {
    refetchOnMount: false,
    keepPreviousData: true,
  });
  const selectedProvider = pvd.data ?? DEFAULT_PROVIDER;
  const isFootballComboDisabled = isSabaComboDisabled(
    selectedProvider,
    "football",
  );
  const updateOddsType = useMutation(mutation.updateOddsType, {
    onSuccess: (value) => {
      queryClient.setQueryData(["oddsType"], value);
    },
  });
  const updateBetType = useMutation(mutation.updateBetType, {
    onSuccess: (value) => {
      queryClient.setQueryData(["betType"], value);
    },
  });

  const updateBetTicketInfoPayload = useMutation(
    mutation.updateBetTicketInfoPayload,
    {
      onSuccess: (payload) => {
        queryClient.setQueryData(["betTicketInfoPayload"], payload);
      },
    }
  );

  useEffect(() => {
    updateBetTicketInfoPayload.mutate([]);
    updateOddsType.mutate(2); // euro odds type
    updateBetType.mutate("comboStep");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    {
      label: (
        <>
          <img
            className="w-5 inline mr-2 align-baseline"
            src="/svg/soccer.svg"
            alt="ฟุตบอล"
          />
          Football
        </>
      ),
      onClick: (index: number) => {
        setTabIndex(index);
      },
      component: (
        <SportTableLiveAndToday
          todayTitle="Football/Today"
          liveTitle="Football/Live"
          sport="football"
          isBetTypeSelectorDisabled
        />
      ),
    },
    {
      label: (
        <>
          <img
            className="w-5 inline mr-2 align-baseline"
            src="/svg/basketball.svg"
            alt="บาสเก็ตบอล"
          />
          Basketball
        </>
      ),
      onClick: (index: number) => {
        setTabIndex(index);
      },
      component: (
        <SportTableLiveAndToday
          liveTitle="Basketball/Live"
          todayTitle="Basketball/Today"
          sport="basketball"
          isBetTypeSelectorDisabled
        />
      ),
    },
  ].filter((_, index) => !isFootballComboDisabled || index !== 0);

  const activeTabIndex = Math.min(tabIndex, tabs.length - 1);

  useEffect(() => {
    if (tabIndex !== activeTabIndex) {
      setTabIndex(activeTabIndex);
    }
  }, [activeTabIndex, tabIndex]);

  return (
    <div className="desktop:container desktop:mx-auto">
      <ComboTabs
        currentIndex={activeTabIndex}
        data={tabs}
      />
    </div>
  );
};

export default Combo;
